getScaledFont = function (s, f, min, max) {
	fs = s * f;
	if (fs < min)
		fs = min;
	if (fs > max)
		fs = max;
	return fs + '%';
};

// document.body.setScaledFont(0.2);
function scaleFonts(things) {
	things.each(function(){
		var $t = $(this);
		var w = $t.width();
		if (w !== $t[0].cacheWidth) {
			var scale = $t.attr('scale'),
				width = $t[0].offsetWidth,
				max = $t.attr('scale-max'),
				min = $t.attr('scale-min');

			var set = getScaledFont(width, scale, parseInt(min), parseInt(max));
			$t.css('font-size', set);
			$t[0].cacheWidth = w;
		}
	});
}
$(document).on('__ready __dialog', function(){
	$toscale = $('[scale]');
	scaleFonts($toscale);
	window.onresize = function () {
		scaleFonts($toscale);
	};

	$specialScale = $('.header__logosub [scale]');
	setInterval(function(){
		scaleFonts($specialScale);
	},16);
});
function scrollControl(main, dialog, preload) {
  var self = this;
  self.$main = $(main);
  self.$mainContent = $('.main__content', self.$main)
  self.$dialog = $(dialog);
  self.$preload = $(preload);

  if (!self.$main.length) { console.error('ScrollControl: no main found', main) }
  if (!self.$dialog.length) { console.error('ScrollControl: no dialog found', dialog) }
  if (!self.$preload.length) { console.error('ScrollControl: no preload found', preload) }

  self.originalMarginTop = parseInt(self.$main.css('margin-top'), 10);
  self.saveScrollPos = 0;
  self.stateIs = '';

  self.set = function(key) {
    self.stateIs = (key);
    var sct = window.sessionStorage.scrollPosition;
    // var h = $(window).height();

    if (key === 'dialog') {
      // dialog
      $(window).scrollTop(0);
      self.saveScrollPos = sct;

      self.$main.addClass('main--dialog').addClass('disabled').css('margin-top', sct * -1 + self.originalMarginTop);

      self.$dialog.fadeIn(300)
    }
    // if (key === 'preload') {
    // 	// preload
    // 	$(window).scrollTop(0);
    // 	self.saveScrollPos = sct;
    // 	self.$main.css({
    // 		position: 'fixed',
    // 		'margin-top': sct*-1 + self.originalMarginTop,
    // 		// 'margin-right': self.scrollBarWidth,
    // 		overflow: 'hidden',
    // 		top: 0,
    // 		bottom: 0,
    // 		left: 0,
    // 		right: 0
    // 	}).addClass('disabled');
    // }
    if (key === 'main') {
      self.$dialog.fadeOut(400, function() {
        self.$main.removeClass('main--dialog').removeClass('disabled').css('margin-top', self.originalMarginTop);
        $(window).scrollTop(self.saveScrollPos);
      })
    }
  }

  this.getScrollbarWidth = function() {
      var outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.width = '100px';
      outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

      document.body.appendChild(outer);

      var widthNoScroll = outer.offsetWidth;
      // force scrollbars
      outer.style.overflow = 'scroll';

      // add innerdiv
      var inner = document.createElement('div');
      inner.style.width = '100%';
      outer.appendChild(inner);

      var widthWithScroll = inner.offsetWidth;

      // remove divs
      outer.parentNode.removeChild(outer);

      self.scrollBarWidth = widthNoScroll - widthWithScroll;
  }
  this.getScrollbarWidth();

  // var mainContent = this.$mainContent.html() ? this.$mainContent.html().replace(/\n+|s+|\s+/g, '') : '';

  var splitPath = window.location.pathname.split('/').filter(String);
  splitPath.pop();
  // var path = splitPath.join('/');

  // if (mainContent.length === 0 && path !== 'blog/event') {
  //   this.$mainContent.load(window.location.protocol + '//' + window.location.host + '/' + path + '/' + ' .main__content', function(e) {
  //     var title = $('<div class="f">' + e + '</div>').find('title').text();
  //     window.homeTitle = title;
  //     $(window).trigger('scroll');
  //     $(document).trigger('__ready');
  //   })
  // } else {
    window.homeTitle = $('head title').text();
  // }
}

var scroll = new scrollControl('.main', '.dialog', '.header');

$(document).on('__ready', function() {
	var $header = $('.header');
	var $preloader = $('.preloader');
	var $preloaderbg = $preloader.find('.animatedbackground');
	var $preloaderLogo = $preloader.find('.animatedlogo');

	var $burgermenu = $header.find('.header__mobtrigger');

	// intro animation
	if(!sessionStorage.skipAnimation && !$preloader.hasClass('preloader--hide')) {
		$preloaderLogo.css('opacity', '1');
		var myVivus = new Vivus('panzerhalle_logo', {
			type: 'scenario',
			duration: 120,
			start: 'autostart',
			animTimingFunction: Vivus.EASE
		}, function(cb) {
			// animation done
			$preloader.removeClass('animate');
			$header.removeClass('animate');
			sessionStorage.skipAnimation = true;
		});
	} else {
		$preloaderbg.hide();
		$preloaderLogo.css('opacity', '1').css('transition', 'none');
		$header.find('.header__b2b').css('transition', 'none');
		$header.find('.header__b2c').css('transition', 'none');
		$preloader.removeClass('animate');
		$header.removeClass('animate');
	}


	// event handlers
	$burgermenu.on('click', toggleMenu)
});

var toggleMenu = function() {
	$this = $(this)
	if ($this.hasClass('close')) {
		$this.removeClass('close')
		$('.header__content').removeClass('open').stop().slideUp(500)
		$('body').removeClass('noscroll')
	} else {
		$this.addClass('close')
		$('.header__content').addClass('open').stop().slideDown(500)
		$('body').addClass('noscroll')
	}
}

$(document).on('__ready', function(){
	var $nav = $('.hero__quicknav');
	var pos;
	$('.hero__subtext bdi, .hero__subtext i').on('mouseover', function(){
		pos = $(this).position();
		$nav.css({
			left: pos.left,
			top: pos.top - ($nav.outerHeight() / 2) + ($(this).outerHeight() / 2),
			opacity: 1
		});
	});

	$nav.on('mouseleave', function(){
		$nav.css({
			opacity: 0
		});

		var transD = (parseFloat($nav.css('transition').split(' ')[1]) * 1000) || 200;

		setTimeout(function(){
			$nav.css({
				left: -500,
				top: -500
			})
		}, transD)
	});
});
var ovslider = function(el, minwidth, gutter){
	var self = this;
	
	el = el;
	var wrapper = el.children().first();
	this.els = wrapper.children();


	this.elsInView = this.els.length;
	this.elsPassed = 0;
	this.elsOver = 0;
	this.absPos = 0;
	this.panPos = 0;

	this.elWidth = minwidth;

	var c = {
		out: 'slide-out',
		in: 'slide-in',
		left: 'slide-out-left',
		right: 'slide-out-right'
	};

	this.setup = function(){
		var overflow = 0;
		self.elWidth = el.width() / self.els.length;
		while(self.elWidth < minwidth) {
			overflow++;
			self.elsInView = self.els.length - overflow;
			self.elWidth = el.width() / self.elsInView;
		}
		var totalWidth = self.elWidth * self.els.length;
		totalWidth = totalWidth + (gutter * self.els.length);

		wrapper.css('width', totalWidth);
		self.els.css('width', self.elWidth);

		setTimeout(function(){
			window.menublocks.synch();
			window.menuTitles.synch();
		},50);
	};
	this.setupSlides = function(){
		if (self.elsPassed < 0) {
			self.elsPassed = 0;
		}
		self.elsOver = self.els.length - (self.elsInView + self.elsPassed);

		var maxout = 50;
		while (self.elsOver < 0) {
			self.elsPassed--;
			self.elsOver = self.els.length - (self.elsInView + self.elsPassed);
			maxout--;
			if (maxout === 0) {
				console.error('not enough Elements');
				return false;
			}
		}

		self.els.each(function(i){
			var $t = $(this);
			var e = i+1;
			if (e <= self.elsPassed) {
				$t.removeClass([c.in, c.right].join(' ')).addClass([c.out, c.left].join(' '));
			}
			if (e > self.elsPassed && e <= (self.elsInView + self.elsPassed)) {
				$t.removeClass([c.right, c.left, c.out].join(' ')).addClass([c.in].join(' '));
			}
			if (e > (self.elsInView + self.elsPassed)) {
				$t.removeClass([c.in, c.left].join(' ')).addClass([c.out, c.right].join(' '));
			}
		});

		if (self.elsPassed > 0) {
			el.addClass('overflow-left');
		}else{
			el.removeClass('overflow-left');
		}
		if (self.elsOver > 0) {
			el.addClass('overflow-right');
		}else{
			el.removeClass('overflow-right');
		}

		var negPos = self.elWidth * self.elsPassed;
		wrapper.css('transform', 'translate3D(-'+negPos+'px, 0, 0)');
		self.absPos = negPos*-1;
	};

	this.goToSlide = function(ind) {
		if (ind === '+') {
			self.elsPassed++;
			self.setupSlides();
		}else if (ind === '-') {
			self.elsPassed--;
		}else{
			self.elsPassed = ind - 1;
		}
		self.setupSlides();
	}

	this.runSetup = function(){
		self.setup();
		self.setupSlides();
	};
	this.runSetup();

	this.pan = function(pos) {
		var negPos = self.absPos + (pos);
		wrapper.css({
			transform: 'translate3D('+negPos+'px, 0, 0)'
		});
		self.panPos = pos;
	};

	var endfn = false;
	el.on('touchstart mousedown', function(){
		endfn = true;
		
		wrapper.css({
			transition: 'none',
			'-webkit-transition': 'none'
		});
	}).on('touchend', function(){
		self.slipeEnd();
		endfn = false;
	});

	$(document).on('mouseleave mouseup', function(){
		self.slipeEnd();
		endfn = false;
	})

	this.slipeEnd = function(){
		if (!endfn) {
			return false;
		}
		// setTimeout(function(){
			wrapper.css({
				transition: 'transform 450ms',
				'-webkit-transition': 'transform 450ms'
			});
		// });
		var panDir = '+';
		var panAmount = (self.panPos / self.elWidth);
		var moveBy = 0;

		// if (self.panPos < -80 || self.panPos > 80) {
			if (panAmount < 0) {
				panDir = '-';
				panAmount= panAmount*-1;
			}

			moveBy = Math.floor(panAmount + 0.6);
		// }

		setTimeout(function(){
			if (moveBy) {
				// console.log(moveBy, panDir, self.elsPassed);
				if (panDir == '+') {
					self.elsPassed = self.elsPassed - moveBy;
				}else{
					self.elsPassed = self.elsPassed + moveBy;
				}

				self.setupSlides();
			}else{
				wrapper.css({
					transform: 'translate3D('+self.absPos+'px, 0, 0)'
				});
			}
		});
	}

	if (el.length) {
		this.hammer = new Hammer(el[0]);
		this.hammer.on('pan', function(ev) {
			self.pan(ev.deltaX);
		});
	}

	var to;
	$(window).on('resize', function(){
		clearTimeout(to);
		to = setTimeout(function(){
			self.setup();
			self.runSetup();
		}, 200);
	});
}

$(document).on('__ready', function(){
	var dummy = [];
	$('.lunch__day').each(function(index){
		//dummy[index] = new ovslider($(this), 210, 0);
	});
	// window.menulist = new ovslider('.markthalle__menu__day', 210, 0);

	// $(document).off('click').on('click', '.markthalle__menu__card', function () {

	// 	var r = $(this).hasClass('slide-out-right');
	// 	var l = $(this).hasClass('slide-out-left');
	// 	if(r === true) {
	// 		menulist.goToSlide('+');
	// 	}
	// 	if(l === true) {
	// 		menulist.goToSlide('-');
	// 	}
	// });
});
function menu(){
	var t = this;
	var days = [
		'SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA'
	];

	t.setNav = function(els) {
		t.nav = els;
		t.nav.off('click').on('click', function(){
			t.setDay($(this).attr('setDay'));
		});
	};
	t.setCards = function(els) {
		t.cards = els;
	};

	t.setDay = function(day){
		if (typeof day == 'number') {
			t.day_key = days[day];
		}else{
			t.day_key = day;
		}

		t.nav.each(function(){
			if ($(this).attr('setday') == t.day_key) {
				$(this).addClass('is-active');
			}else{
				$(this).removeClass('is-active');
			}
		});

		t.cards.each(function(){
			var $t = $(this);
			if ($t.attr('day') == t.day_key) {
				$t.addClass('on').removeClass('off');
			}else{
				$t.addClass('off').removeClass('on');
			}
		});

	};
}

$(document).on('__ready', function(){

	var mh = new menu();
	var date = new Date();
	mh.setNav($('.lunch__days__item'));
	mh.setCards($('.lunch__card__content, .lunch__day'));
	mh.setDay(date.getDay());

	//generate swiper menu for mobile
	var daySwiper = new Swiper ('.lunch__days', {
		loop: false,
		slidesPerView: 'auto',
		freeMode: true,
		simulateTouch: false,
		breakpoints: {
			1040: {
				simulateTouch: true,
			}
		}
	})
});
$(document).on('__ready', function(){
	var $ani = $('.svg_animate');

	$ani.each(function(){
		var id = $(this).attr('id');
		var type = $(this).attr('data-style') || 'oneByOne';
		var time = 100;

		var myVivus = new Vivus(id, {
			type: type,
			duration: time,
			onStart: function(mv) {
				var $el = $(mv.el);
				$el.find('.comeInFromRight, .comeInFromLeft').addClass('doItNow');
			}
		});
	});
});
function sameHeight(name){
	var t = this;
	t.$els = $('[data-sameheight="'+name+'"]');
	t.$aniels = $('[data-sameheight-animate="'+name+'"]');

	this.name = name;

	var timeout = 0;
	if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
		timeout = 350;
	}
	// if (name == 'menu') {alert(timeout)}

	this.synch = function(){
		var largest = 0;
		t.$els.css('height', '');

		function resize(){
			t.$els.each(function(){
				var h = this.scrollHeight;
				if (h > largest) {
					largest = h;
				}
			});

			if (t.$aniels.length) {
				var aniPadding = parseInt(t.$aniels.css('padding-top')) + parseInt(t.$aniels.css('padding-bottom'));
				t.$aniels.css({'height': largest + (aniPadding)});
			}

			t.$els.css('height', largest);
		}

		setTimeout(function(){
			resize();
		},timeout);
	};

	var to;
	$(window).on('resize', function(){
		if (!t.deleted) {
			clearTimeout(to);
			to = setTimeout(function(){
				t.synch();
			},250);
		}
	});
}

$(document).on('__ready __dialog', function(){
	window.menublocks = new sameHeight('menu');
	menublocks.synch();

	window.menuTitles = new sameHeight('menu_name');
	menuTitles.synch();

	window.coworking = new sameHeight('coworking');
	coworking.synch();

	window.peopleBoxes = new sameHeight('people');
	peopleBoxes.synch();


	setTimeout(function(){
		window.menublocks.synch();
		window.menuTitles.synch();

		eventBoxes.map(function(el){
			el.synch();
		});
	},500);


	if (document.fonts) {
		document.fonts.ready.then(function () {
			window.menublocks.synch();
			window.menuTitles.synch();
			window.coworking.synch();

			eventBoxes.map(function(el){
				el.synch();
			});
		});
	}

	window.eventBoxes = [];
	function resizeBoxes(){
		var $els = $('.events__list__box__details');

		eventBoxes.map(function(el){
			el.deleted = true;
		});

		eventBoxes.length = 0;

		$els.each(function(){
			var $t = $(this);
			$t.removeAttr('data-sameheight');
			var top = Math.round($t.offset().top);
			$t.attr('data-sameheight', 'eventBox_'+top);
			eventBoxes.push(new sameHeight('eventBox_'+top));
		});

		eventBoxes.map(function(el){
			el.synch();
		});

	}

	resizeBoxes();

	window.resizeBoxes = resizeBoxes;

	var to;
	$(window).on('resize', function(){
		clearTimeout(to);
		to = setTimeout(function(){
			resizeBoxes();
		},280);
	}).trigger('resize');

	$(window).on('load', function() {
		$(window).trigger('resize');
	});
});
function canvasColor(container, sourceImage, color, addClass) {
	var self = this;
	var pic = new Image();

	var w = container.outerWidth();
	var h = container.outerHeight();

	var canvas = document.createElement('canvas');
	canvas.width = w;
	canvas.height = h;
	canvas.className = addClass || 'nope';
	var ctx = canvas.getContext('2d');
	container.append(canvas);

	var tintCanvas = document.createElement('canvas');
	tintCanvas.width = w;
	tintCanvas.height = h;
	var tintCtx = tintCanvas.getContext('2d');

	pic.onload = function() {
		w = pic.width;
		h = pic.height;
		canvas.width = w;
		canvas.height = h;
		tintCanvas.width = w;
		tintCanvas.height = h;

		tintCtx.fillStyle = color;
	    tintCtx.fillRect(0, 0, tintCanvas.width, tintCanvas.height);
	    tintCtx.globalCompositeOperation = 'destination-atop';
	    tintCtx.drawImage(pic, 0, 0);

	    ctx.drawImage(tintCanvas, 0, 0);
	}
	pic.src = sourceImage;

	this.pic = pic;
	this.canvas = canvas;
}

$(document).on('__ready', function() {
	var canvases = [];
	$('.insertCanvas').each(function() {
		var c = $(this).find('a');
		var image = $(this).find('img').attr('data-original');
		var color = '#b59e61';

		canvases.push(new canvasColor(c, image, color, 'hover-image'));
	});

	$('.jobs__logo').each(function() {
		// var c = $(this);
		// var image = $(this).find('img').attr('data-original');
		// var color = '#ffffff';

		// canvases.push(new canvasColor(c, image, color, 'white-image'));
	});
});
$(document).on('__dialog', function() {
	$('.insertDialogCanvas').each(function() {
		var $t = $(this).find('a');
		var image = $t.attr('data-imgurl');
		new canvasColor($t, image, '#acacac', 'main-image');
		new canvasColor($t, image, '#b59e61', 'hover-image');
	});
});

function onloadCallback() {
	grecaptcha.ready(function(){
		loadCaptcha();
	});
}
function loadCaptcha() {
	grecaptcha.render("recaptcha", {
		sitekey: "6LdcQigqAAAAABGF3RVqVJppJ5DNup6rphco3sdK"
	});
}

/* global history */
$(document).on('__ready __dialog', function() {
	var lastUrl = '';
	var lastTitle = '';
	if (history.pushState) {
		$('a[dialog]').off('click').on('click', function(e) {
			sessionStorage.scrollPosition = $(window).scrollTop()
		//$('a[href*="'+window.location.host+'"]').off('click').on('click', function(){
			var link = $(this).attr('href');
			var uriPath = link.replace(window.location.protocol + '//' + window.location.host + '/', '');
			if (uriPath.length) {
				lastUrl = window.location.href;
				lastTitle = $('head title').html();


				history.pushState(null, lastTitle, link);

				$('.dialog').html('').addClass('loadingDialogContent');

				setTimeout(function() {
					$('.dialog').load(link + ' .dialog__content', function(e) {
						var title = $('<div class="f">' + e + '</div>').find('title').text();
						$('html title').text(title);
						$(document).trigger('__dialog');
						$('.dialog').removeClass('loadingDialogContent');

						//create yt player in overlay
						var $ytvideo = $('.js-video');
						$('.video__play').fadeIn(500);
						addVideoEventHandlers();
						$ytvideo.each(createYtPlayer)

						//reinit swiper
						var gallerySwiper = new Swiper('.dialog__gallery__swiper', {
							loop: false,
							slidesPerView: 1,
							simulateTouch: true,
							breakpoints: {
								1040: {
									simulateTouch: true,
								},
							},
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
						})

						// init recaptcha
						if(e.indexOf('id="recaptcha"') >= 0){

							// load recaptcha if not loaded yet
							if(typeof grecaptcha === 'undefined'){
								var script = document.createElement('script');
								script.setAttribute('src','https://www.google.com/recaptcha/api.js?onload=onloadCallback');
								script.setAttribute('async', true);
								document.head.appendChild(script);
							} else {
								loadCaptcha();
							}

						}
					});
				}, 0);
				scroll.set('dialog');
				return false;
			}
		});


		$(window).on('popstate', function(e) {
		    if (e.originalEvent.state == null) {
		    	var title = lastTitle;
				var link = lastUrl;
				$('head title').html(title);
				history.pushState(null, title, link);

				scroll.set('main');
		    }
		});
	}

	// console.log('dialog__close');
	$('.dialog__close').on('click', function() {
		//var link = window.location.protocol + '//'' + window.location.host + '/';
		var splitpath = window.location.pathname.split('/').filter(String)

		// url is cut off by one directory on reload of overlay page, hence this
		if (splitpath.length === 1) {
			splitpath.length = 0
		}
		if (splitpath.length >= 2) {
			splitpath.pop()
		}

		var path = splitpath.join('/')


		console.log(splitpath)

		if (path !== '') {
			var link = window.location.protocol + '//' + window.location.host + '/' + path + '/'
		} else {
			var link = window.location.protocol + '//' + window.location.host + '/'
		}


		if (history.pushState) {
			var title = $('head title').html();
			history.pushState(null, title, link);
		} else {
			window.location.href = link;
		}
		scroll.set('main');

		if (window.homeTitle) {
	    	var title = window.homeTitle;
			$('head title').html(title);
		}
	});

	// var actNav = $('.dialog__content').attr('actNav') || 0;

	// if (actNav !== 0) {
	// 	window.navigation.navLock = 0;
	// 	window.navigation.setRightNav(actNav);
	// 	window.navigation.navLock = 1;
	// }
});

$(function() {
	var $loadMore = $('.loadMore');

	var templates = {
		Instagram: $('.image_template')[0],
		Facebook: $('.text_template')[0]
	};

	var $wrapper = $('.hub__content');
	var social = juicerjs({
		feed: 'panzerhalle',
		limit: 8,
		templates: templates,
		human_time: {
			day: ['Tag', 'Tage'],
			hour: ['Stunde', 'Stunden'],
			minute: ['Minute', 'Minuten'],
			second: ['Sekunde', 'Sekunden']
		},
		onSuccess: function(newPosts, a, b, c) {
			// callback
			$wrapper.append(newPosts.join(''));
			$loadMore.css('opacity', '1');
			setTimeout(function() {
				$wrapper.find('[data-original]').each(function() {
					src = $(this).attr('data-original');
					if (src === '') {
						$(this).parent().addClass('no-image')
					} else {
						$(this).css({
							'background-image': 'url("' + src + '")'
						});
					}
				})
			});
		}
	});

	social.load();

	$loadMore.on('click', function() {
		$loadMore.css('opacity', '0');
		social.more();
		return false;
	});
});

$(function() {
	var $input = $('.nl-input');
	var $submit = $('.nl-submit');
	var $form = $('.nl-form');
	//
	// var $input_c = $('.cm-email');
	// // var $submit_c = $('#cm-form-1-0-submit');
	//
	// var $form_c = $('#cm-form-1-0');
	//
	// $input.on('change input', function() {
	// 	$input_c.val($input.val());
	// });
	//
	// $submit.on('click', function() {
	// 	// $submit_c.click();
	// 	$form_c.submit();
	// });
	//
	function validateEmail(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}
	$form.on('submit', function(e) {
		var email = $input.val();
		var valid = validateEmail(email);
		e.preventDefault();

		if (valid) {
			$.ajax({
				url: '/newsletter-subscribe',
				type: 'POST',
				data: {
					email: email
				},
				success: function(data) {
					if (data.http_status_code === 201) {
						$('.newsletter-input > *').fadeOut(200);
						$('.newsletter-input .teaser__input__success').fadeIn(300);
						$('.newsletter-input__policy').fadeOut(300);
					}
				}
			});
		}
		//
	});
});

$(document).ready(function () {

    var cookieHeight = parseInt($('.cookie').css('height'), 10)

    var $cookieBtn = $('.cookie').find('.cookie__close')

    var onDesktop = $('.header__mobtrigger').css('display') === 'none'

    var cookieAccepted = window.localStorage.cookieAccepted || false;


    if (!cookieAccepted || cookieAccepted === 'false') {

        $('.cookie').slideDown(600)


        if (onDesktop) {
            calcCookieBanner(cookieHeight)
        }

    } else {
        $('.cookie').hide()
    }

    $cookieBtn.on('click', function () {
        $('.cookie').slideUp(300)

        calcCookieBanner(0)

        window.localStorage.cookieAccepted = true;
        cookieAccepted = true;
    })

    $(window).on('resize', function() {
        onDesktop = $('.header__mobtrigger').css('display') === 'none'
        if (!cookieAccepted || cookieAccepted === 'false') {
            if (onDesktop) {
                calcCookieBanner(cookieHeight)
            } else {
                calcCookieBanner(0)
            }
        }
    })

})


function calcCookieBanner(cookieHeight) {

    $('.preloader').css({
        paddingTop: cookieHeight
    })

    $('.header').css({
        top: cookieHeight
    })

    $('.main').css({
        paddingTop: cookieHeight
    })

    $('.dialog').css({
        paddingTop: cookieHeight
    })
}

$(function() {
	$('.js-overlay-closer-line').click(function() {
		$('.overlay').remove();
	})
});

function loadMoreEvents(options) {
    var current = options.current;
    var oC = current;
    var all = options.allHidden;

    var max = 2;
    var to = 200;
    var count = 1;

    function show() {
        var i = current;

        var $el = $(all[current])
        $el.removeClass('is-hiding').addClass('invisible');
        
        setTimeout(function() {
            $el.addClass('animate-in');
        }, to * count);

        count++;
        current++;

        if (current < oC + max) {
            show();
        }
    }
    show();

    return current;
}

$(document).on('__ready', function() {
    $('.js-events').each(function(){
        var $loadmore = $(this).find('.loadMoreEvents');
        var $hiddenEvents = $(this).find('.singleevent.is-hiding');

        var visibleHidden = 0;
        if ($hiddenEvents.length) {
            $loadmore.on('click', function() {
                visibleHidden = loadMoreEvents({
                    current: visibleHidden,
                    allHidden: $hiddenEvents
                });
    
                
    
                if (visibleHidden >= $hiddenEvents.length) {
                    $loadmore.addClass('no-more');
                }
                return false;
            });
        } else {
            $loadmore.fadeOut(300);
        }
    });

    //load more press events
    var $loadmore_press = $('.loadMorePressEvents')
    var $press_events = $('.press__report')
    var $hidden_press_events = $('.press__report.is-hiding')

    var visibleHidden_press = 0;
    if ($hidden_press_events.length) {
        $loadmore_press.on('click', function() {
            visibleHidden_press = loadMoreEvents({
                current: visibleHidden_press,
                allHidden: $hidden_press_events
            })
            if (visibleHidden_press >= $hidden_press_events.length) {
                $loadmore_press.fadeOut(300)
            }
            return false;
        })
    } else {
        $loadmore_press.fadeOut(0)
    }

    // load more jobs 
    var $loadmore_jobs = $('.loadMoreJobs')
    var $jobs = $('.jobs__offer')
    var $hidden_jobs = $('.jobs__offer.is-hiding')

    var visibleHidden_jobs = 0
    if ($hidden_jobs.length) {
        $loadmore_jobs.on('click', function() {
            visibleHidden_jobs = loadMoreEvents({
                current: visibleHidden_jobs,
                allHidden: $hidden_jobs
            })
            if (visibleHidden_jobs === $hidden_jobs.length) {
                $loadmore_jobs.fadeOut(300)
            }
            return false;
        })
    } else {
        $loadmore_jobs.fadeOut(300)
    }
});
$(function() {
    var tag = document.createElement('script');
    
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
})

var createYtPlayer = function() {
    $this = $(this)
    var player;
    var youtubeId = $this.data('youtube');
    player = new YT.Player(youtubeId, {
        videoId: youtubeId
    })
}

var playVideo = function() {
    $this = $(this);
    var p = $this.closest('.video').find('iframe').get(0);
    var overlay = $this.closest('.video').find('.video__content')
    p.contentWindow.postMessage( JSON.stringify({
        'event': 'command',
        'func': 'playVideo',
        'args': []
    } ), '*');
    overlay.fadeOut(500)
}

window.onYouTubeIframeAPIReady = function() {
    var $ytvideo = $('.js-video');
    $('.video__play').fadeIn(500);
    addVideoEventHandlers();
    $ytvideo.each(createYtPlayer)
}

function addVideoEventHandlers() {
    $('.video__play').on('click', playVideo);
}
// gallery in dialog overlay

// all gallery swipers

$(document).on('__ready', function(){

	var gallerySwiper = new Swiper ('.dialog__gallery__swiper', {
		loop: false,
		slidesPerView: 1,
		simulateTouch: true,
		breakpoints: {
			1040: {
				simulateTouch: true,
			}
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
	})

	var bigGallerySwiper = new Swiper('.slider-gallery__swiper', {
		loop: true,
		slidesPerView: 1,
		simulateTouch: true,
		navigation: {
            nextEl: '.gallery-button-next',
            prevEl: '.gallery-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		  },
	})
});

$(document).on('__ready', function() {
    var $download_button = $('.press-download')
    var $agreed = $('#download-kit')

    $download_button.on('click', function(e) {
        if(!$agreed.is(':checked')) {
            e.preventDefault();
            $agreed.next('label').addClass('error')
        }
    })

    $agreed.on('click', function(e) {
        if($(this).is(':checked')) {
            $(this).next('label').removeClass('error')
        }
    })
})
$(document).on('__ready __dialog', function() {
    var $email_form = $('.dialog__press__form')
    var $submit_btn = $('.js-button-sendmail')

    var $mail_field = $email_form.find('#mail')
    var $checkbox = $email_form.find('#accept')


    $submit_btn.off('click').on('click', function(e) {
        e.preventDefault()
        if (validateMail($mail_field) && $checkbox.is(':checked')) {
            var mail = $mail_field.val();
            $email_form.addClass('disabled');

            $.post({
                url: window.location.href,
                data: {
                    sendpdf: mail,
                },
                success: function(response) {
                    $email_form.addClass('mail-sent');
                },
                error: function(res) {
                    window.alert('Ein fehler ist aufgetreten, bitte versuchen sie später erneut.')
                },
            })
        } else {
            if (!$checkbox.is(':checked')) {
                $checkbox.next('label').addClass('error')
            }
            if (!validateMail($mail_field)) {
                $mail_field.addClass('error')
            }
        }
    })

    $mail_field.on('blur', function() {
        if(validateMail($(this))) {
            $(this).removeClass('error')
        }
    })

    $checkbox.on('click', function(e) {
        if($(this).is(':checked')) {
            $(this).next('label').removeClass('error')
        }
    })
})

function validateMail(mail) {
    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    var mailValid = mail.val().match(emailRegex) && mail.val().trim() !== ''
    return mailValid
}
$(function() {
	$('a[href$="#footer"]').addClass('js-scroll-contact');

	// scroll down button on landing hero
	$(document).on('click', '.js-scroll-about', function(event) {

		var $scrollTo = $('.hero').next('.text')

		var menuheight = $('.header').height()
		var heromargin = parseInt($('.hero').css('margin-bottom'), 10);

		$('html, body').animate({
			scrollTop: $scrollTo.offset().top - menuheight - heromargin
		}, 1000);

	});

	//scroll to contact / footer
	$(document).on('click', '.js-scroll-contact', function(e) {
		e.preventDefault()

		//close mobile menu
		if($('.header__mobtrigger').hasClass('open')) {
			$('.header__mobtrigger').removeClass('close')
			$('.header__content').removeClass('open').stop().slideUp(500)
			$('body').removeClass('noscroll')
		}

		var $scrollTo = $('.footer')

		var menuheight = $('.header').height()

		$('html, body').animate({
			scrollTop: $scrollTo.offset().top - menuheight
		}, 1000);
	})

});

$(document).ready(function() {

	if (window.location.hash) {
		var menuheight = $('.header').height()
		setTimeout(function() {
				$('html, body').scrollTop(0);
				$('html, body').animate({
					scrollTop: $(window.location.hash).offset().top - menuheight - 80,
				}, 700)
		}, 0);
	}

	$('a[href^="#"], a[href^="/#"]').on('click', function() {
		var $this = $(this);
		var target = $this.attr('href');
		var hash = target.split('#')[1];
		var menuheight = $('.header').height();

		if ($('#' + hash).length) {
			$('html, body').animate({
				scrollTop: $('#' + hash).offset().top - menuheight - 80,
			}, 700)
			window.location.hash = hash

			return false
		}

	})
});


$(document).on('__ready __dialog', function() {
	var ww = $(window).width();
	var useImage = 'large';
	if (ww < 550) {
		useImage = 'small';
	}

	$('[image-large]').each(function() {
		var $t = $(this);
		var image = $t.attr('image-' + useImage);

		if (typeof image === 'undefined') {
			image = $t.attr('image-large');
		}

		$(this).removeAttr('image-large image-small');
		$t.attr('data-original', image);
	});

	setTimeout(function() {
		$('[data-original]').lazyload({
			threshold: 500
		});
		$(window).trigger('scroll');
	})

	if ($('.dialog').hasClass('is-visible')) {
		scroll.set('dialog')
	}
});

function eventRegistration(e){
	e.preventDefault();

	$('.js-input-wrap').removeClass('error');

	var t = $(e.target);
	var form = t.closest('form');
	
	$.ajax({
		url: form.attr('action'),
		type: 'POST',
		data: form.serialize(),
		dataType: 'json',
		success: function(data) {
			if(typeof data.message !== 'undefined' && data.message === 'missing_fields'){
				grecaptcha.reset();
				data.data.forEach(function(item){
					$('[name="'+item+'"]').closest('.js-input-wrap').addClass('error');
				});
			} else if(data.success === true){
				$('.js-eventregistration-1').slideUp(200);
				$('.js-eventregistration-2').slideDown(200);
			}
		},
		error: function(xhr, status, error) {},
	  });
}

$(function() {
	$(document).trigger('__ready');
});
